// export const appAPI = 'https://api.tapblet.app/?';
// export const appURL = 'https://erpnext.tapblet.app';

export const appAPI = 'https://api.paragonpetsgroup.net/?';
export const appURL = 'https://erpnext.paragonpetsgroup.net';
